import { render, staticRenderFns } from "./FacebookRegistration.vue?vue&type=template&id=d52a85c2&"
import script from "./FacebookRegistration.vue?vue&type=script&lang=js&"
export * from "./FacebookRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports